import { z } from "zod";
import { paginatedResponse } from "../utils";

const StatusSchema = z.object({
    id: z.string(),
    status_key: z.string(),
    status_name: z.string(),
    status_name_eng: z.string(),
});

export const STATUS_KEYS = {
    Sold: "Sold",
    Reservation: "Reservation",
    FictionalReservation: "FictionalReservation",
    InitialReservation: "InitialReservation",
};

export const statusApiSchema = {
    status: StatusSchema,
    getStatusesResponse: paginatedResponse(StatusSchema),
};
